import { useShadowRoot } from "@/helpers/ShadowRootContext.ts";
import { useEffect } from "react";

export const useRangePickerScrollBehavior = (hideDatePicker: boolean) => {
  const { shadowRoot } = useShadowRoot();

  useEffect(() => {
    if (!hideDatePicker) {
      const dayPickerPopup = shadowRoot.querySelector(".daypicker-popup");
      if (window.innerWidth < 768 && dayPickerPopup) {
        dayPickerPopup?.scrollIntoView({ block: "end", behavior: "smooth" });
      }
    } else {
      const daypickerButton = shadowRoot.querySelector(".c-be-range-picker-wrapper");
      if (window.innerWidth < 768 && daypickerButton) {
        daypickerButton?.scrollIntoView({ block: "start", behavior: "smooth" });
      }
    }
  }, [hideDatePicker, shadowRoot]);
};
